module.exports = __webpack_public_path__ + "static/media/icone_orphelinat.90e056c2.svg";